import {
  Project,
  ProjectItem,
  ProductMainInfo,
  ProductCharacteristic,
  ProductCharacteristicTypes,
  PurchaserTermsType,
  ApplicationRequirements,
  Subcontracts,
} from '@/types/supplier-search'
import { SuppliersSearchParam } from '@/types/suppliers';
import {FileModel} from "@/types/common";

export const currentProject: Project = {
  Id: -1,
  Name: '',
  Additional: {
    Files: [],
    Text: ''
  },
  ApplicationEndDateInner: (() => {
    const date = new Date();
    date.setDate(date.getDate() + 7);
    return date;
  })(),
  ApplicationEndDateTimeZoneId: 3,
  PurchaserTermsType: PurchaserTermsType.PurchaserTerms,
  Properties: {
    Delivery: true,
    Prepayment: false,
  },
  Items: [],
}

export const currentProjectOffersRequest: Project = {
  Id: -1,
  Name: '',
  Additional: {
    Files: [],
    Text: '',
    ApplicationRequirements: ApplicationRequirements.CommercialOfferPhotoCopy
  },
  ApplicationEndDateInner: (() => {
    const date = new Date();
    date.setDate(date.getDate() + 7);
    return date;
  })(),
  ApplicationEndDateTimeZoneId: 3,
  PurchaserTermsType: PurchaserTermsType.CustomerTerms,
  Properties: {
    Delivery: true,
    Prepayment: false
  },
  Items: [],
  InvitedOrganizations: [],
  DeliveryAddress: '',
  DeliveryAddressOkato: ''
}

export const currentSubcontracts: Subcontracts = {
  Positions: [],
  Project: {
    Files: [],
    AdditionalText: '',
    ApplicationEndDateInner: (() => {
      const date = new Date();
      date.setDate(date.getDate() + 7);
      return date;
    })(),
    Properties: {
      Delivery: true,
      Prepayment: false,
      PurchaserTermsType: 2,
    },
    DeliveryAddress: '',
    DeliveryAddressOkato: '',
    KladrCode: '',
    OrderId: -1,
  }
}

export const currentPosition: ProjectItem = {
  Id: -1,
  ProductId: -1,
  Name: '', //cntrl
  Amount: 1, //cntrl
  Okpd2Name: '', //ProductMainInfo
  Okpd2: '', //ProductMainInfo
  Okved2Name: '', //ProductMainInfo
  Okved2: '', //ProductMainInfo
  Price: 0, //ProductMainInfo
  Budget: 0,
  UnitCode: '', //ProductMainInfo
  UnitName: '', //ProductMainInfo
  UnitShortName: '', //ProductMainInfo
  DeliveryAddress: '', //ProductMainInfo first item
  DeliveryAddressOkato: '', //ProductMainInfo first item
  //DeliveryAddresses: [],
  Characteristics: [], //cntrl
  FullName: '', //ProjectName + Name
  WithoutPrice: false
}

export const emptyCharacteristic: ProductCharacteristic = {
  Id: -1,
  Index: 0,
  Name: 'Введите название',
  Comment: '',
  UnitCode: '',
  UnitName: '',
  UnitShortName: '',
  UnitSelectorOpen: false,
  NameFocused: false,
  ShowTypeSelector: false,
  TypeSelectorFocused: false,
  Value: {
    Type: ProductCharacteristicTypes.String,
    Value: ''
  }
}

export const initialMainProductinfo: ProductMainInfo = {
  Quantity: 1,
  Price: 0,
  Okpd2: '',
  Okpd2Code: '',
  Okved2: '',
  Okved2Code: '',
  ProductId: -1,
  UnitCode: '',
  UnitName: '',
  UnitShortName: '',
  ProductCharacteristic: [],
  TaxPercent: 0
}

export const supplierSearchParam: SuppliersSearchParam = {
  filter: {
    name: [],
    searchTenderNames: true,
    searchOfferNames: true,
    okpd2: [],
    searchOkpd2Up: true,
    searchOkpd2Down: true,
    okved2: [],
    lastYearActivityOnly: undefined,
    isMsp: undefined,
    isLiqiudated: false,
    kladrs: [],
  },
  ranking: {
    customer: [],
    kladr: [],
    fz44: true,
    fz223: true,
    commercial: true,
    otcSections: true,
    nonOtcSections: true,
    isLegalEntity: true,
    isIndividual: true,
    hasOtcLicense: false,
  },
  pageSize: 200
}